// extracted by mini-css-extract-plugin
export var arrow = "_lk-1";
export var content = "_lk-0";
export var highlighted = "_lk-2";